import { useGraphQLMutation } from '@opengov/bnp-core';
import { useQueryClient } from '@tanstack/react-query';

import { graphql } from '../../../../../gql-generated/hasura';
import {
  UpdateMenuStoryNameByIdForOnlinePublicationMutation,
  UpdateMenuStoryNameByIdForOnlinePublicationMutationVariables
} from '../../../../../gql-generated/hasura/graphql';
import { HASURA_SERVICE_URL } from '../../../../../config/config';
import { useToast } from '../../../Toast/context/useToast.context';

import { setupOnlinePublicationQueryKeys } from './setupOnlinePublicationQueryKeys';

const UpdateMenuStoryNameByIdForOnlinePublicationDocument = graphql(`
  mutation UpdateMenuStoryNameByIdForOnlinePublication($id: uuid!, $displayName: String) {
    update_publicationNavigationMenuStories(
      where: { id: { _eq: $id } }
      _set: { displayName: $displayName }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`);

export type UseUpdateMenuStoryNameMessages = {
  successTitle: string;
  successBody?: string;
  errorTitle: string;
  errorBody?: string;
};

export type UseUpdateMenuStoryNameContext = {
  menuId: string;
};

export function useUpdateMenuStoryName(
  context: UseUpdateMenuStoryNameContext,
  messages: UseUpdateMenuStoryNameMessages
) {
  const queryClient = useQueryClient();
  const { toggleToast } = useToast();

  return useGraphQLMutation<
    UpdateMenuStoryNameByIdForOnlinePublicationMutation,
    UpdateMenuStoryNameByIdForOnlinePublicationMutationVariables
  >({
    mutationKey: [...setupOnlinePublicationQueryKeys.all, 'updateMenuStoryName', context],
    document: UpdateMenuStoryNameByIdForOnlinePublicationDocument,
    url: HASURA_SERVICE_URL,
    options: {
      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: setupOnlinePublicationQueryKeys.menuStories({ menuId: context.menuId })
        });
        toggleToast({
          title: messages.successTitle,
          body: messages.successBody,
          severity: 'success'
        });
      },
      onError: () =>
        toggleToast({
          title: messages.errorTitle,
          body: messages.errorBody,
          severity: 'error'
        })
    }
  });
}
